export default __webpack_public_path__ + "static/media/680.f30ef389.gif";